import { Component } from "@angular/core";
import { AuthenticationService } from "@auth/authentication.service";
import { PdfService } from "@shared/pdf-viewer/pdf.service";

@Component({
  selector: "admin-layout",
  templateUrl: "./admin-layout.component.html",
})
export class AdminLayoutComponent {
  constructor(
    public authenticationService: AuthenticationService,
    public pdfService: PdfService
  ) {}
}
